import Const from 'constants';

let SalaryCap = {
    setInnerSalaryCapFromStorage(data) {
        return (dispatch) => {
            dispatch(this.setInnerSalaryCap(data, {saveToStorage: false}));
        };
    },

    setInnerSalaryCap(data, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SALARY_CAP_SET_INNER,
                data,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('salaryCap', function (state) {
                    const {salaryCap} = state;
                    return {
                        innerCapBoundaries: salaryCap.getInnerCapBoundaries(),
                    };
                }),
            );
        };
    },

    setOuterSalaryCapFromSportConfig() {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            dispatch({
                type: Const.SALARY_CAP_SET_OUTER,
                data: {
                    min: sportConfig.getMinSalaryCap(),
                    max: sportConfig.getMaxSalaryCap(),
                },
            });
        };
    },
};

export default SalaryCap;
